// // import { createSlice } from '@reduxjs/toolkit'

// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   PRICES: {},
// };
// export const priceReducer = createSlice({
//   name: "priceReducer",
//   initialState,
//   reducers: {
//     UPDATE_PRICES: (state, action) => {
//       state.PRICES = action.payload;
//     },
//   },
// });

// // Action creators are generated for each case reducer function
// export const { UPDATE_PRICES } = priceReducer.actions;

// export default priceReducer.reducer;
const INITIAL_STATE = {
  PRICES: {},
};

const priceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UPDATE_PRICES":
      return { ...state, PRICES: action.payload };

    default:
      return state;
  }
};

export default priceReducer;
